import { useEffect, useState } from 'react';
import axiosInstance from '../utils/axios';

/**
 * Whether AI candidate scoring is currently effective — sourced from the backend
 * (GET /api/config), which computes env-master AND admin-toggle. The UI follows this,
 * so an admin flipping the toggle (or the env master) is reflected on next load.
 * Defaults to false (scoring UI hidden) until the value is known.
 */
export function useAiScoringEnabled(): boolean {
  const [enabled, setEnabled] = useState<boolean>(false);

  useEffect(() => {
    let active = true;
    axiosInstance
      .get('/config')
      .then((res) => {
        if (active) setEnabled(res.data?.aiScoringEnabled === true);
      })
      .catch(() => {
        if (active) setEnabled(false);
      });
    return () => {
      active = false;
    };
  }, []);

  return enabled;
}
